export function isMemberDetailResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const m = value.member;
    return Boolean(m &&
        typeof m.id === 'string' &&
        /^\d{6,20}$/.test(m.nationalId) &&
        typeof m.givenNames === 'string' &&
        typeof m.familyNames === 'string' &&
        (m.email === null || typeof m.email === 'string') &&
        (m.primaryPhone === null || typeof m.primaryPhone === 'string') &&
        (m.secondaryPhone === null || typeof m.secondaryPhone === 'string') &&
        (m.status === 'active' || m.status === 'inactive') &&
        Number.isInteger(m.version) &&
        m.version > 0 &&
        !Number.isNaN(Date.parse(m.createdAt)) &&
        !Number.isNaN(Date.parse(m.updatedAt)) &&
        (m.history === undefined ||
            (Array.isArray(m.history) &&
                m.history.length > 0 &&
                m.history.every((h) => (h.status === 'active' || h.status === 'inactive') &&
                    typeof h.reason === 'string' &&
                    Number.isInteger(h.sequence) &&
                    !Number.isNaN(Date.parse(h.occurredAt))))));
}
